var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDegree = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "47px",
    viewBox: "0 0 40 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "93979169-A848-405B-A658-2C299F9E5202") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile",
    transform: "translate(-167.000000, -2131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Info",
    transform: "translate(100.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "education",
    transform: "translate(0.000000, 1500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(67.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#191919",
    points: "-7.10542736e-15 3.55271368e-15 40 3.55271368e-15 40 40 26.1586791 40.1577505 19.9334102 47 13.6959566 40.1496781 -7.10542736e-15 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8579227,17.3835728 L34.07,17.2716432 L33.8579227,17.1597135 L20.5,10.1994552 L20.4410896,10.17 L20.3821793,10.1994552 L8.06991535,16.6000651 L6.99774691,17.1597135 L6.93,17.1891687 L6.93,26.8710853 C6.92999509,27.1383553 7.14579977,27.3554759 7.4130649,27.3570957 L7.77241806,27.3570957 C8.03968319,27.3554759 8.25548787,27.1383553 8.25548296,26.8710853 L8.25548296,18.0345322 L12.6001216,20.2937443 L12.6001216,25.8018624 C12.5986569,25.822455 12.5986569,25.8431256 12.6001216,25.8637183 L12.6001216,25.9344107 L12.6001216,25.9727024 L12.6001216,26.3850749 C12.8210354,27.404224 13.6693445,28.3026069 15.0507923,28.980076 C16.7754306,29.7520525 18.6490828,30.1342252 20.5382917,30.0993727 L20.5883655,30.0993727 C22.4852119,30.1349849 24.3663697,29.7496997 26.0964836,28.9712394 C27.4779314,28.2937703 28.3262405,27.3953875 28.5500998,26.3497287 L28.5500998,25.9491383 C28.5500998,25.9196831 28.5500998,25.8902279 28.5500998,25.8607727 C28.5521838,25.834304 28.5521838,25.8077125 28.5500998,25.7812438 L28.5500998,20.155305 L33.8579227,17.3835728 Z M25.5221077,27.8401606 C24.243753,28.4705014 22.4499327,28.8328001 20.6089842,28.8328001 L20.5324007,28.8328001 C18.6943977,28.8328001 16.9005774,28.4705014 15.6192772,27.8401606 C14.4852529,27.2864033 13.8107293,26.5559149 13.8166204,25.8813914 L13.8166204,20.9329216 L20.3792338,24.3467766 L20.4351986,24.3791773 L20.494109,24.3467766 L27.3248028,20.7885913 L27.3012003,25.3482527 L27.3247645,25.8813914 C27.3306555,26.5559149 26.656132,27.2864033 25.5221077,27.8401606 Z M28.3586412,18.8150944 L27.0891231,19.4748904 L20.4263621,22.9476557 L13.763601,19.4748904 L12.7827437,18.9564793 L9.52500109,17.2716432 L20.4263621,11.592685 L31.3247775,17.2686976 L28.3586412,18.8150944 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDegree);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_degree.16b6d01e7e0a0bb08ee2996e66766146.svg";